/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  Approach,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    ApproachFromJSON,
    ApproachToJSON,
} from '../models';

export interface SendApproachRequest {
    xApplicationScope: ApplicationScope;
    approach: Approach;
}

/**
 * 
 */
export class ContactControllerApi extends runtime.BaseAPI {

    /**
     * send approach
     * send approach
     */
    async sendApproachRaw(requestParameters: SendApproachRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling sendApproach.');
        }

        if (requestParameters.approach === null || requestParameters.approach === undefined) {
            throw new runtime.RequiredError('approach','Required parameter requestParameters.approach was null or undefined when calling sendApproach.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/approaches`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApproachToJSON(requestParameters.approach),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * send approach
     * send approach
     */
    async sendApproach(requestParameters: SendApproachRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendApproachRaw(requestParameters, initOverrides);
    }

}
